import { Box } from '@aicon-dev/caas-core';
import styled from 'styled-components';

export const SectionTitle = styled(Box)`
  padding: 0 16px;
  /* background: #f6f8f9; */
  color: #7f8892;
  font-weight: 500;
  font-size: 14px;
  /* line-height: 1.125rem; */
  margin-bottom: 8px;
  /* margin-top: 8px; */

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionContent = styled.div<{ contentColor?: string }>`
  ${({ contentColor }) => `
        color: ${contentColor ? contentColor : '#414c5c'};
    `}

  padding: 8px 16px;
  font-weight: 400;
  font-size: 1.125rem;
`;

export const WorkTitle = styled(Box)<{ background?: string }>`
  ${({ background }) => `
        background: ${background};
    `}

  display:flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  font-size: 18px;
  font-weight: 400;
  color: #fff;
  cursor: pointer;
`;
